import React from 'react'
import PropTypes from 'prop-types'

// Page heading, sitting directly under the breadcrumbs. Deliberately small:
// a wide-tracked brand-coloured label rather than a large display heading, so
// the page's own content leads instead of the chrome.
const PageTitle = (props) => {
  const { pagetitle } = props
  return (
    <div className="mt-1 mb-4 md:flex md:items-center md:justify-between">
      <div className="flex-1 min-w-0">
        <h1 className="text-[10px] uppercase tracking-[0.4em] text-clcpurple-dark dark:text-clcpurple-light font-bold">
          {pagetitle}
        </h1>
      </div>
      <div className="mt-3 flex-shrink-0 flex md:mt-0 md:ml-4">
        { React.Children.map(props.children, (child) => {
          return (child && <> { child } </>)
        })}
      </div>
    </div>
  )
}

export default PageTitle

PageTitle.propTypes = {
  pagetitle: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.object
  ])
}
